:host {
  display: flex;
  flex-direction: column;
  overflow: auto;
}

collection {
  display: flex;
  flex-direction: column;
  flex: 0 0 36px;
  box-sizing: border-box;
  width: 100%;
  padding-left: 24px;
  cursor: pointer;
  font-family: monospace;
  justify-content: center;
}

collection:hover {
  background-color: var(--primary, #1976d2);
}